import { Component, OnInit } from '@angular/core';
import { ChangePasswordBindingModel } from 'src/app/api/models/web-booking.models';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends BaseComponent implements OnInit {

  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;

  ngOnInit() {
    this.app.pageTitle = 'Change your password';
    this.baseTriggerChild.subscribe(event => {
      this.app.spinner.hide();
      this.scrollTo();
    });
    this.start();
  }

  backToLogin() {
    this.app.router.navigate([AppConstants.RouteLogin]);
  }

  submit() {
    var model: ChangePasswordBindingModel = {
      oldPassword: this.oldPassword,
      newPassword: this.newPassword,
      confirmPassword: this.confirmNewPassword
    };
    this.app.spinner.show();
    this.app.webBookingService.ChangePassword(model)
      .subscribe(
        data => {
          this.oldPassword = '';
          this.newPassword = '';
          this.confirmNewPassword = '';
          this.app.spinner.hide();
          this.showInfoMessage('Password updated successful.');
          this.app.router.navigate([AppConstants.RouteSelectConsultation]);
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }
}

